import { createSelector } from 'reselect'

const getAgreementRequestState = state => state.corporateAgreementRequest

export const isFetchingRequest = createSelector(
  getAgreementRequestState,
  requestState => (requestState ? requestState.isFetching : null)
)
export const getRequestError = createSelector(
  getAgreementRequestState,
  requestState => (requestState && requestState.error ? requestState.error.description[0] : null)
)
export const getRequestSuccess = createSelector(
  getAgreementRequestState,
  requestState => (requestState ? requestState.data : null)
)
